// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixLocation from 'wix-location'
$w.onReady(function () {
	// TODO: write your page related code here...

	//check query params to see if need to scroll to custom element
	if(wixLocation.query.hasOwnProperty('redeem_online')) {
		$w('#CustomElement1').scrollTo()
	}
	$w('#CustomElement1').setAttribute('geo', 'nl');

});